import React from 'react';

class ReadOnlyItemVariant extends React.Component {
  render() {
    return <input {...this.props.input} className={`form-control`} disabled />;
  }
}

export default ReadOnlyItemVariant;
